/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./DonePrompt.css";

class DonePrompt extends Component {
  render() {
    return (
      <div className="DonePrompt-view">
        <div className="DonePrompt-prompt">
          <div className="DonePrompt-tick"></div>
          <div className="DonePrompt-text">你的指示已被處理。</div>

          <a href="/loginEmail">
            <div className="DonePrompt-btn">返回</div>
          </a>
        </div>
      </div>
    );
  }
}

export default DonePrompt;
